import { useMutation } from '@apollo/client';
import { DeleteOrganisationWebhookDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteWebhookTRPC } from './useDeleteWebhookTRPC';

export const useDeleteWebhook = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteWebhookGraphQL, graphqlState] = useMutation(
    DeleteOrganisationWebhookDocument,
    {
      update: (cache) => {
        evictField(cache, 'organisation_webhook');
      },
    }
  );

  const trpcMutation = useDeleteWebhookTRPC();

  const deleteWebhook = async (id: string): Promise<void> => {
    if (trpcEnabled) {
      await trpcMutation.deleteWebhook(id);

      return;
    }

    const result = await deleteWebhookGraphQL({ variables: { Id: id } });
    if (!result.data) {
      throw new Error('Failed to delete webhook');
    }
  };

  if (trpcEnabled) {
    return {
      deleteWebhook,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteWebhook,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
